import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DatatableRootObject, DataTablesResponse } from '../interfaces/interfaces.index';
import { HTTP_OPTIONS, URL_SERVICIOS } from '../shared/config/config';
import { MailQueue } from '../interfaces/mail-queue.interface';
const URL = `${URL_SERVICIOS}MailQueue`;

@Injectable({
  providedIn: 'root'
})
export class MailQueueService {

  constructor(public http: HttpClient) { }

  getQueueDatatables = (par: DatatableRootObject) =>
    this.http.post<DataTablesResponse<MailQueue>>(`${URL}/datatables`, par, HTTP_OPTIONS)

  retryEmail = (id: number) => this.http.put(`${URL}/Retry/${id}`, null, HTTP_OPTIONS);

  deleteQueue = (id: number) => this.http.delete(`${URL}/${id}`, HTTP_OPTIONS);

}
